var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYandexZnak1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5865_15594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 23.9755C18.6139 23.9755 23.9755 18.6139 23.9755 12C23.9755 5.38605 18.6139 0.0244141 12 0.0244141C5.38605 0.0244141 0.0244141 5.38605 0.0244141 12C0.0244141 18.6139 5.38605 23.9755 12 23.9755Z",
    fill: "#1A1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3334 19.5178H13.7046V6.51554H12.5334C10.3868 6.51554 9.26233 7.58887 9.26233 9.19109C9.26233 11.0089 10.0379 11.8511 11.6423 12.9244L12.9646 13.8155L9.16456 19.5155H6.33789L9.75789 14.4266C7.79122 13.0222 6.68456 11.6511 6.68456 9.33776C6.68456 6.44665 8.70011 4.47998 12.5157 4.47998H16.3157V19.5133H16.3334V19.5178Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5865_15594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandexZnak1);
export default __webpack_public_path__ + "static/media/Yandex_znak 1.57b01bcef05233fbf8f8372ef960aacb.svg";
export { ForwardRef as ReactComponent };